import { render, staticRenderFns } from "./TradingType.vue?vue&type=template&id=e207a8e6&scoped=true&"
import script from "./TradingType.vue?vue&type=script&lang=js&"
export * from "./TradingType.vue?vue&type=script&lang=js&"
import style0 from "./TradingType.vue?vue&type=style&index=0&id=e207a8e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e207a8e6",
  null
  
)

export default component.exports